import { useAiAction } from './useAiAction';
import type { ToneScore } from '@/types/coparenting';

interface ToneAnalysisResult {
  classification: ToneScore;
  confidence: number;
  suggestion?: string;
  reasoning?: string;
}

export function useToneAnalysis(householdId: string | null) {
  const { callAction, isLoading } = useAiAction(householdId);

  const analyzeTone = async (draft: string): Promise<ToneAnalysisResult | null> => {
    return callAction<ToneAnalysisResult>('analyze_message_tone', { draft });
  };

  return { analyzeTone, loading: isLoading };
}
